/* eslint-disable no-empty-function */
import { InsiderServiceConfig, RNInsiderUserWeb } from 'app/services/Insider.types';
// TEMPORARY: This is a placeholder implementation of InsiderService for web.
// The full Insider Web integration is being developed in a separate branch.
// Do not rely on this stub for production behavior. Replace with full service once ready.
const InsiderServiceWeb: InsiderServiceConfig = {
  init() {},

  getUser() {
    return {} as RNInsiderUserWeb;
  },

  async handleModifyUser() {},

  handleHomePageView() {},

  handleProductPageView() {},

  handleListingPageView() {},

  handleAttractionPageView() {},

  handleOffersPageView() {},

  handleEvent() {},
};

export default InsiderServiceWeb;
